// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { key16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-key': IconKey;
    }
}

/**
 * The icon component for the 'key' icon
 */
export class IconKey extends Icon {
    public constructor() {
        super(key16X16);
    }
}

registerIcon('icon-key', IconKey);
export const iconKeyTag = 'nimble-icon-key';
